import { Currency } from "@redotech/money/currencies";
import { moneyFormat } from "@redotech/money/util";
import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

// Items + shipping + taxes as amount + currency. Mirrors the search index's
// total_price_with_shipping_and_taxes_int (incl. its pre-field fallback).
export function orderTotalAmount(row: FulfillmentGroupData): {
  amount: number;
  currency: Currency;
} {
  const amount =
    row.totalPriceWithShippingAndTaxes != null
      ? Number(row.totalPriceWithShippingAndTaxes.amount)
      : Number(row.totalPrice.amount) +
        Number(row.totalShippingCost.amount) +
        Number(row.totalTax.amount);
  return {
    amount,
    currency:
      row.totalPriceWithShippingAndTaxes?.currency ?? row.totalPrice.currency,
  };
}

export function formatOrderTotal(row: FulfillmentGroupData): string {
  return moneyFormat(orderTotalAmount(row));
}

export const OrderTotalCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Total", cell: (row) => formatOrderTotal(row) };
